import React, { useState } from 'react';
import { Modal, Input, Form, Button } from 'antd';
import { useNavigate } from 'react-router-dom';

const FlowDetailsModal = ({ showModal, setShowModal,handleNext,object,setIsCreatingFlow }) => {
  const [form] = Form.useForm();
  const navigate = useNavigate();

//   const handleNext = () => {
//     form
//       .validateFields()
//       .then((values) => {
//         console.log('Form values:', values);
//         setShowModal(false);
//         navigate('/flows');
//       })
//       .catch((info) => {
//         console.log('Validation failed:', info);
//       });
//   };

  const handleCancel = () => {
    setShowModal(false);
    setIsCreatingFlow(false);
    form.resetFields();

  };

  // Auto-generate API name on blur of name field
  const handleNameBlur = () => {
    const nameValue = form.getFieldValue('name');
    if (nameValue) {
      const apiNameValue = nameValue.replace(/\s+/g, '');
      form.setFieldsValue({ apiName: apiNameValue });
    }
  };

  return (
    <Modal
      title="Flow Details"
      open={showModal}
      onCancel={handleCancel}
      zIndex={1002}   // higher than sidebar
      footer={[
        <Button key="cancel" onClick={handleCancel}>
          Cancel
        </Button>,
        <Button key="next" 
            type="primary" 
            onClick={() => {
                form
                .validateFields()
                .then((values) => {
                    handleNext(values);  // Pass validated form values to parent
                    setShowModal(false); // Optionally close modal here
                })
                .catch((error) => {
                    console.log("Validation Failed:", error);
                });
            }}
        >
          Next
        </Button>,
      ]}
    >
      <Form layout="vertical" form={form}>
        <Form.Item
          name="name"
          label="Name"
          rules={[{ required: true, message: 'Please enter a name' }]}
        >
          <Input placeholder="Enter name" onBlur={handleNameBlur} />
        </Form.Item>

        <Form.Item
          name="apiName"
          label="API Name"
          rules={[{ required: true, message: 'Please enter an API name' }]}
        >
          <Input disabled placeholder="Enter API name" />
        </Form.Item>

        <Form.Item name="description" label="Description">
          <Input.TextArea rows={3} placeholder="Enter description" />
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default FlowDetailsModal;
